import { GetListParams } from 'react-admin';
import { CustomDataProvider } from '../../../providers/CustomDataProvider';
import { baseUrl, httpClient } from '../../../providers/AppDataProvider';

export class ActivityDataProvider implements CustomDataProvider {
  // eslint-disable-next-line class-methods-use-this
  async getList(resource: string, params: GetListParams): Promise<any> {
    if (resource !== 'activityUserActivityStats')
      return Promise.reject(new Error('Unsupported resource'));
    console.log('activityUserActivityStats getList params:', params);

    const { page = 1, perPage = 10 } = params.pagination || {};
    const { filter = {}, meta = {} } = params;
    const sort = JSON.stringify(params.sort);

    // 构建查询参数
    const searchParams = new URLSearchParams({
      sort,
      page: page.toString(),
      size: perPage.toString(),
      query: JSON.stringify(filter),
      ...meta,
    });
    // 仅当存在筛选值时追加，确保日期格式为 ISO 字符串
    if (filter?.startDate) {
      const startDate = typeof filter.startDate === 'string' && filter.startDate.includes('T')
        ? filter.startDate
        : new Date(filter.startDate).toISOString();
      searchParams.set('startDate', startDate);
    }
    if (filter?.endDate) {
      const endDate = typeof filter.endDate === 'string'&& filter.endDate.includes('T')
        ? filter.endDate
        : new Date(filter.endDate).toISOString();
      searchParams.set('endDate', endDate);
    }

    // 构建请求 URL
    const url = `${baseUrl}/activity/adminGetUserActivityStats?${searchParams.toString()}`;

    try {
      const { json } = await httpClient(url);

      // 根据您的数据结构处理数据
      // 这里假设您的 API 返回格式可能不同，需要特殊处理
      let rows: any[] = [];
      let total = 0;

      // 根据实际 API 响应结构调整
      if (json?.data) {
        rows = json.data?.dailyCompletions;
      } else if (Array.isArray(json)) {
        rows = json;
      } else {
        // 默认处理
        rows = json?.list ?? json?.items ?? json?.records ?? [];
      }
      total = rows.length;
      // 添加数据量检查，避免处理过多数据
      if (rows.length > 10000) {
        console.warn('Large dataset detected:', rows.length, 'items. Consider server-side pagination.');
      }
      // data 按照日期倒序（最新在前）
      rows.sort((a, b) => {
        const dateA = new Date(a.date || 0).getTime();
        const dateB = new Date(b.date || 0).getTime();
        return dateB - dateA;
      });

      // 确保每条记录都有 id，并限制处理的数据量
      const allData = rows.slice(0, 10000).map((r: any, i: number) => (r?.id != null ? r : { id: `${i}`, ...r }));

      // 前端分页处理
      const startIndex = (page - 1) * perPage;
      const endIndex = startIndex + perPage;
      const data = allData.slice(startIndex, endIndex);

      return { data, total };
    } catch (error) {
      console.error('ActivityDataProvider getList error:', error);
      throw error;
    }
  }

  // eslint-disable-next-line class-methods-use-this
  async create(resource: string, params: any): Promise<any> {
    // 仅拦截 activity/tasks 列表对应的创建
    if (resource !== 'activityUserActivityStats')
      return Promise.reject(new Error('Unsupported resource'));

    return { data: {} };
  }

  // eslint-disable-next-line class-methods-use-this
  async update(resource: string, params: any): Promise<any> {
    if (resource !== 'activityUserActivityStats')
      return Promise.reject(new Error('Unsupported resource'));

    return { data: {} };
  }

  // eslint-disable-next-line class-methods-use-this
  async delete(resource: string, params: any): Promise<any> {
    if (resource !== 'activityUserActivityStats')
      return Promise.reject(new Error('Unsupported resource'));

    return { data: {} };
  }
}

// 创建实例并导出
export const activityDataProvider = new ActivityDataProvider();
